var trim = require('./trim');
var dasherize = require('./dasherize');
var cleanDiacritics = require('./cleanDiacritics');

module.exports = function slugify(str) {
  return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/slugify.js
 ** module id = 450
 ** module chunks = 0
 **/